import { apiSlice } from './apiSlice'

import type { PnLRow } from '../../pages/dashboard/pnl/PnLTable'

/**
 * Futures Position dashboard data — `GET /api/v1/dashboard/futures-position`.
 *
 * Mirrors FastAPI `FuturesPositionDashboardResponse` (camelCase aliases). BE
 * returns DATA ROWS only; column/format config lives in
 * `pages/dashboard/futuresPosition/mockData.ts`. The "Total lot" pivot has
 * dynamic flag columns, so the payload carries `flags` + nested per-flag cells
 * (`values[flag] = {buy, sell}`) that the FE flattens into column keys.
 * Source: Report DB (`DATABASE_URL_REPORT`).
 */
export interface TotalLotRow {
  fullSymbol: string
  values: Record<string, { buy: number | null; sell: number | null }>
  isTotal?: boolean
}

export interface FuturesPositionDashboardResponse {
  londonRobusta: PnLRow[]
  newyorkArabica: PnLRow[]
  futuresPosition: PnLRow[]
  totalLot: { flags: string[]; rows: TotalLotRow[] }
  /** PBI card `report_date` = MIN(max selected date, today). ISO `YYYY-MM-DD`. */
  reportDate?: string | null
}

export interface FuturesPositionDashboardQuery {
  /** ISO date `YYYY-MM-DD`; omitted = no lower bound. */
  fromDate?: string
  /** ISO date `YYYY-MM-DD`; omitted = no upper bound. */
  toDate?: string
}

const dashboardFuturesPositionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFuturesPositionDashboard: builder.query<
      FuturesPositionDashboardResponse,
      FuturesPositionDashboardQuery
    >({
      query: ({ fromDate, toDate } = {}) => ({
        url: '/dashboard/futures-position',
        params: {
          ...(fromDate ? { fromDate } : {}),
          ...(toDate ? { toDate } : {}),
        },
      }),
    }),
  }),
})

export const { useGetFuturesPositionDashboardQuery } = dashboardFuturesPositionApi
